import { addDoubleQuotes, toStringify } from '../utils/smartutils';
import { BLOOD_TYPE } from '../utils/constants';

export function studentListByFilter(filter) {
  let classesId;
  let responsiblesId;
  let menusId;

  if (filter.classes) {
    classesId = filter.classes.map((classes) => classes.id);
  }

  if (filter.responsibles) {
    responsiblesId = filter.responsibles.map((responsibles) => responsibles.id);
  }

  if (filter.menus) {
    menusId = filter.menus.map((menus) => menus.id);
  }

  const query = `{studentListByFilter(filter:{id:0, classes:[${
    classesId || []
  }],responsibles:[${responsiblesId || []}],menus:[${
    menusId || []
  }], onlyActive:${
    filter.onlyActive
  }}){id, fullName, gender, phone, cellPhone, cellPhoneAux, dateOfBirth, classesNames, studentOrigin, active, value, label}}`;

  return query;
}
export function studentListForAge(filter) {
  let classesId;
  let responsiblesId;
  let menusId;
  let onlyWithAccess = false;

  if (filter.classes) {
    classesId = filter.classes.map((classes) => classes.id);
  }

  if (filter.responsibles) {
    responsiblesId = filter.responsibles.map((responsibles) => responsibles.id);
  }

  if (filter.menus) {
    menusId = filter.menus.map((menus) => menus.id);
  }

  if (filter.onlyWithAccess) {
    onlyWithAccess = true;
  }

  const query = `{studentListByFilter(filter:{id:0, classes:[${
    classesId || []
  }],responsibles:[${responsiblesId || []}],menus:[${
    menusId || []
  }], onlyActive:${
    filter.onlyActive
  }, onlyWithAccess: ${onlyWithAccess}}){id, fullName, dateOfBirth}}`;

  return query;
}

export function studentFindByIdQuery(id) {
  const query = `{studentListByFilter(filter: {id: ${id}, onlyActive: false}){id,
                                           firstName,
                                            lastName,
                                            fullName,
                                           shortName,
                                         dateOfBirth, 
                                                 cpf,
                                              gender,                                              
                                             zipCode,
                                             address,
                                       addressNumber, 
                                        neighborhood,
                                      addressAdjunct, 
                                  state{id, name, uf},
                  city{id, ibgeId, name, uf, stateId}, 
                                               fileId,
                                      profilePhotoUrl, 
                                                phone, 
                                            cellPhone,
                                         cellPhoneAux, 
                               enrolledMenu{id, name}, 
                                             legacyId,
                                              barcode,
                                         observations, 
                                            bloodType, 
                                         healthIssues, 
                                         specialCares, 
                                            allergies, 
                                            susNumber,
                                     healthPlanNumber,
                                   healthPlanOperator,
                                     pediatricianName,
                                    pediatricianPhone,
                                     pediatricianData,
                                    active,
                                    studentOrigin,
                                    email

                                          }
                  }`;
  return query;
}

export function studentFindByFilter(filter) {
  return `{
  studentListByFilter(filter: ${toStringify(filter)}) {
    id
    firstName
    lastName
    fullName
    shortName
    dateOfBirth
    cpf
    gender
    zipCode
    address
    addressNumber
    neighborhood
    addressAdjunct
    state {
      id
      name
      uf
    }
    city {
      id
      ibgeId
      name
      uf
      stateId
    }
    fileId
    profilePhotoUrl
    phone
    cellPhone
    cellPhoneAux
    enrolledMenu {
      id
      name
    }
    legacyId
    barcode
    observations
    bloodType
    healthIssues
    specialCares
    allergies
    susNumber
    healthPlanNumber
    healthPlanOperator
    pediatricianName
    pediatricianPhone
    pediatricianData
    active
    studentOrigin
    email
  }
}
`;
}

export function saveStudentMutation(values) {
  const classEnrollments = [];
  const transformEnrollment = (item) => {
    const { id, initialDateInMilli, schoolShift, schoolClass } = item;
    if (!id) {
      const updatedItem = {
        id,
        initialDateInMilli,
        finalDateInMilli: 0,
        schoolShift: {
          ...schoolShift,
          filterByStatus: false,
          updaterId: 0,
          active: true,
          classQuantity: 0,
        },
        schoolClass: {
          ...schoolClass,
          filterByStatus: false,
          updaterId: 0,
          active: true,
          studentsQuantity: 0,
          capacity: 0,
        },
        filterByStatus: false,
        updaterId: 0,
        active: true,
      };
      classEnrollments.push(updatedItem);
    }
  };
  const state = values.state ? { ...values.state } : { id: 0 };
  const city = values.city
    ? { ...values.city }
    : { id: 0, ibgeId: 0, stateId: 0 };
  const enrolledMenu = {
    id: values.enrolledMenu ? values.enrolledMenu.id : 0,
    deleted: false,
    filterByStatus: false,
    updaterId: 0,
    inDetail: false,
    studentQuantity: 0,
    active: true,
  };
  const updatedRelatedResponsible = [...values.relatedResponsible];
  if (values.relatedResponsible) {
    for (let i = 0; i < updatedRelatedResponsible.length; i += 1) {
      const {
        id,
        fullName,
        email,
        gender,
        phone,
        cellPhone,
        cellPhoneAux,
        cpf,
      } = updatedRelatedResponsible[i].responsible;
      updatedRelatedResponsible[i] = {
        id: updatedRelatedResponsible[i].id,
        type: updatedRelatedResponsible[i].type,
        accessStudentData: updatedRelatedResponsible[i].accessStudentData,
        takeStudent: updatedRelatedResponsible[i].takeStudent,
        financialContact: updatedRelatedResponsible[i].financialContact,
        emergencyContact: updatedRelatedResponsible[i].emergencyContact,
        responsible: {
          id,
          fullName,
          email,
          gender,
          phone,
          cellPhone,
          cellPhoneAux,
          cpf,
          filterByStatus: false,
          updaterId: 0,
          validateCpfOnSubmit: false,
          chatUserId: updatedRelatedResponsible[i].chatUserId
            ? updatedRelatedResponsible[i].chatUserId
            : 0,
        },
      };
    }
  }

  delete state.value;
  delete state.label;
  delete city.value;
  delete city.label;
  delete enrolledMenu.value;
  delete enrolledMenu.label;
  if (values.classEnrollments) {
    values.classEnrollments.forEach((item) => transformEnrollment(item));
  }

  const mutationQuery = `mutation($firstName: String!, $lastName: String!, $fullName: String!, $shortName: String!) {
    studentSave(
      student: {
            id: ${values.id},
            firstName: $firstName,
            lastName: $lastName,
            fullName: $fullName,
            shortName: $shortName,
            cpf: "${values.cpf ? values.cpf : ''}",
            dateOfBirth: ${
              values.dateOfBirth ? values.dateOfBirth.getTime() : 0
            },
            gender: "${values.gender}",
            zipCode: "${values.zipCode ? values.zipCode : ''}"
            address: "${values.address ? values.address : ''}"
            addressNumber: "${values.addressNumber ? values.addressNumber : ''}"
            neighborhood: "${values.neighborhood ? values.neighborhood : ''}"
            addressAdjunct: "${
              values.addressAdjunct ? values.addressAdjunct : ''
            }"
            state: ${JSON.stringify(state).replace(/"([^(")"]+)":/g, '$1:')},
            city: ${JSON.stringify(city).replace(/"([^(")"]+)":/g, '$1:')},
            phone: "${values.phone ? values.phone : ''}"
            cellPhone: "${values.cellPhone ? values.cellPhone : ''}"
            cellPhoneAux: "${values.cellPhoneAux ? values.cellPhoneAux : ''}"
            enrolledMenu: ${JSON.stringify(enrolledMenu).replace(
              /"([^(")"]+)":/g,
              '$1:'
            )},
            legacyId: ${values.legacyId ? values.legacyId : 0},
            barcode: "${values.barcode ? values.barcode : ''}",
            observations: ${addDoubleQuotes(values.observations)},
            bloodType: "${values.bloodType.value || BLOOD_TYPE.UNIFORMED}",
            healthIssues:  ${addDoubleQuotes(values.healthIssues)},
            specialCares:  ${addDoubleQuotes(values.specialCares)},
            allergies:  ${addDoubleQuotes(values.allergies)},
            susNumber: "${values.susNumber ? values.susNumber : ''}",
            healthPlanNumber: "${
              values.healthPlanNumber ? values.healthPlanNumber : ''
            }",
            healthPlanOperator: "${
              values.healthPlanOperator ? values.healthPlanOperator : ''
            }",
            pediatricianName: "${
              values.pediatricianName ? values.pediatricianName : ''
            }",
            pediatricianPhone: "${
              values.pediatricianPhone ? values.pediatricianPhone : ''
            }",
            pediatricianData: ${addDoubleQuotes(values.pediatricianData)},
            classEnrollments: ${JSON.stringify(classEnrollments).replace(
              /"([^(")"]+)":/g,
              '$1:'
            )},
            relatedResponsible: ${JSON.stringify(
              updatedRelatedResponsible
            ).replace(/"([^(")"]+)":/g, '$1:')},
            fileId: "${values.fileId ? values.fileId : ''}",
            filterByStatus: false,
            updaterId: 0,
            active: ${values.active},
            activeOnLoggedPeriod: false,
            studentOrigin: "${values.studentOrigin.value}"
        }),
    {id}
    }`;
  return mutationQuery;
}

export function studentListForField(filter) {
  let classesId;
  let responsiblesId;
  let menusId;
  let onlyWithAccess = false;

  if (filter.classes) {
    classesId = filter.classes.map((classes) => classes.id);
  }

  if (filter.responsibles) {
    responsiblesId = filter.responsibles.map((responsibles) => responsibles.id);
  }

  if (filter.menus) {
    menusId = filter.menus.map((menus) => menus.id);
  }

  if (filter.onlyWithAccess) {
    onlyWithAccess = true;
  }

  const query = `{studentListByFilter(filter:{id:0, classes:[${
    classesId || []
  }],responsibles:[${responsiblesId || []}],menus:[${
    menusId || []
  }], onlyActive:${
    filter.onlyActive
  }, onlyWithAccess: ${onlyWithAccess}}){id, fullName}}`;

  return query;
}

export function studentExistByCpf(filter) {
  return `{
  studentListByFilter(filter: ${toStringify(filter)}) {
    id
  }
}
`;
}

export function studentListWithClassesNamesByFilter(filter) {
  return `{
  studentListByFilter(
    filter: ${toStringify(filter)}
  ) {
    classesNames
    value
    label
  }
}
`;
}

export function inactivateStudents(students) {
  const studentIds = students.map((student) => student.id);
  return `mutation{inactivateStudents(studentIds:${toStringify(studentIds)})}`;
}
